export interface AccessClaims {
  sub: string;
  email: string;
  roles?: string[];
  /**
   * The firm this advisor belongs to, sourced server-side from
   * `advisor_firm_members` (never from `users.roles`). The API's requireAdvisor()
   * gate rejects any token where this is null, so the UI reads it only to decide
   * what to render — never as an authorization decision of its own.
   */
  advisorFirmId?: string | null;
  exp?: number;
}

/** Decode (NOT verify) a JWT payload. The server verifies; the client only
 *  reads claims to populate the session user. Returns null if malformed. */
export function decodeJwt(token: string): AccessClaims | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), '='));
    const payload = JSON.parse(json) as Record<string, unknown>;
    if (typeof payload.sub !== 'string' || typeof payload.email !== 'string') return null;
    return {
      sub: payload.sub,
      email: payload.email,
      roles: Array.isArray(payload.roles) ? (payload.roles as string[]) : undefined,
      advisorFirmId: typeof payload.advisor_firm_id === 'string' ? payload.advisor_firm_id : null,
      exp: typeof payload.exp === 'number' ? payload.exp : undefined,
    };
  } catch {
    return null;
  }
}
